export interface User {
  id: number;
  email: string;
  full_name: string;
  role: string;
  servis_id: number | null;
  teknisyen_id: number | null;
}

export function isTeknisyen(user: User | null) {
  return user?.role === "teknisyen";
}

export function getUser(): User | null {
  if (typeof window === "undefined") return null;
  const u = localStorage.getItem("user");
  return u ? JSON.parse(u) : null;
}

export function getToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem("token");
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.location.href = "/login";
}

export function isSuperAdmin(user: User | null) {
  return user?.role === "super_admin";
}

export function isFirmaAdmin(user: User | null) {
  return user?.role === "firma_admin" || isSuperAdmin(user);
}

export function isAltServis(user: User | null) {
  return user?.role === "alt_servis";
}
